import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import { useIntl } from "react-intl";
import { useAppSelector } from "@/store/store";

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

function NotificationComponent() {
  const notification = useAppSelector(({ uiState }) => uiState);
  const intl = useIntl();

  const text = notification.messageId
    ? intl.formatMessage(
        { id: notification.messageId, defaultMessage: notification.message },
        notification.values,
      )
    : notification.message;

  return (
    <Snackbar
      open={notification.open}
      TransitionComponent={TransitionUp}
      ContentProps={{
        "aria-describedby": "message-id",
      }}
      message={text}
    />
  );
}

export default NotificationComponent;
